
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/les-mills",
      function () {
        return require("private-next-pages/les-mills.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/les-mills"])
      });
    }
  